import { Typography } from '@mui/material'
import { ButtonMui } from 'src/components/ButtonMui'
import TextFieldMui from 'src/components/TextFieldMui'
import styled from 'styled-components'

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 100%;
  align-items: center;
  padding-bottom: 1rem;
`

export const CustomInputText = styled(TextFieldMui)`
  height: 2.5rem !important;
  margin: 0 !important;
`

export const BoxInputValues = styled.div`
  display: grid;
  grid-template-columns: 2fr 2fr;
  grid-template-rows: 2fr 2fr;
  gap: 1.5rem;
  width: 100%;
`

export const ProductInfoBox = styled(Typography)`
  width: 100%;
  background-color: #839BCB;
  font-weight: bold !important;
  font-size: 16px !important;
  border: 1px;
  border-style: solid;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  padding: 8px 8px 8px 8px;
`

export const CustomButton = styled(ButtonMui)`
`

export const BodyModalAlert = styled.div`
  display: flex;
  width: 100%;
  padding: 15px;
`

export const AlertMessageBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  word-wrap: break-word;
`

export const AlertMessage = styled.span`
`

export const TotalQuantityBox = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: -1.2rem;
  padding-left: 1px;
  padding-right: 1px;
`

export const TotalQuantityInfo = styled(Typography)`
  font-size: 16px !important;
`

export const SuffixWrap = styled.div`
  display: flex;
`
export const Suffix = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px 12px;
  color: #555;
  background-color: #eee;
  height: 40px;
  border: 1px solid #c7c9c7;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  box-sizing: border-box;
  margin-left: 1px;
  color: rgba(0, 0, 0, 0.38);
`
